export default "__VITE_ASSET__Bsa5TqYF__"